import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Icon from 'tbk-components/src/components/Icon';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IMainNavPageProps extends IBaseElementProps {
	children?: any;
	taglineText?: string;
	taglineLink?: ILink;
	calloutButton?: ILink;
	calloutImage?: IImage;
	secondaryNav?: ILink[];
}

const MainNavPage: React.FC<IMainNavPageProps> = ({
	children,
	className,
	classNames = [],
	taglineText,
	taglineLink,
	calloutButton,
	calloutImage,
	secondaryNav = [],
}) => (
	<div className={className || cn('main-nav-page', ...classNames)}>
		<div className="main-nav-page__header">
			<div className="main-nav-page__header-content">
				<div className="main-nav-page__header-tagline">
					<p>
						{taglineText && (
							<span className="desktop-header__tagline-text">
								{taglineText}{' '}
							</span>
						)}
						{taglineLink && (
							<a
								href={taglineLink.href}
								className="desktop-header__tagline-link"
							>
								{taglineLink.label}
							</a>
						)}
					</p>
				</div>
				<div className="main-nav-page__callout">
					{calloutButton && (
						<Button
							className="btn btn-secondary"
							{...calloutButton}
						/>
					)}
				</div>
			</div>
			<div className="main-nav-page__callout-image">
				{calloutImage && (
					<Image
						className="main-nav-page__callout-image"
						{...calloutImage}
					/>
				)}
			</div>
		</div>
		<div className="search-bar">
			<form
				className="desktop-header__search d-flex"
				action="/"
				method="get"
			>
				<input
					name="s"
					className="form-control"
					type="text"
					placeholder="Search..."
					aria-label="Search"
				/>
				<button className="btn" type="submit">
					<i className="icon-search" />
					<span className="visually-hidden">Search</span>
				</button>
			</form>
		</div>
		<div className="main-nav-page__content">{children}</div>
		<div className="main-nav-page__secondary-nav">
			<ul className="nav flex-column">
				{secondaryNav.length > 0 &&
					secondaryNav.map((secondaryNavItem, index) => (
						<li className="nav-item" key={index}>
							<a
								className="nav-link"
								href={secondaryNavItem.href}
							>
								{secondaryNavItem.label}
							</a>
						</li>
					))}
			</ul>
		</div>
	</div>
);

export default MainNavPage;
